


































import ApiClient from '@/common/api'
import BlueButton from '@/views/atoms/BlueButton.vue'
import TextBox from '@/views/atoms/TextBox.vue'
import SelectBox from '@/views/atoms/SelectBox.vue'
import Global from '@/common/global.js'
import ErrorLabel from '@/views/atoms/ErrorLabel.vue'
import BackButton from '@/views/atoms/BackButton.vue'
import store from '@/store'
import PopupChangePassowrd from '@/views/template/PopupChangePassowrd.vue'

export default
  components: {
    ApiClient
    BlueButton
    TextBox
    SelectBox
    Global
    ErrorLabel
    BackButton
    PopupChangePassowrd
  }

  data: () ->
    level: Global.level()
    defaultLevel: '0'
    paramsId: false
    showChangePassword: false
    id: ''

  created: () ->
    store.dispatch('initPostParam')
    store.dispatch('setErrors', [])
    if @.$route.params.id > 0
      @paramsId = true
      api = new ApiClient()
      data = await api.get('/fc/tanto/detail/' + @.$route.params.id)
      @defaultLevel = data.detail.level
      store.dispatch('setDetailParam', data)

  methods: {
    save_click: () ->
      api = new ApiClient()
      data = await api.post('/fc/tanto/save')
      if data.errors.length == 0
        @$router.push '/tanto'
    back: () ->
      @$router.push '/tanto'
    edit_click: () ->
      api = new ApiClient()
      data = await api.post('/fc/tanto/save')
      if data.errors.length == 0
        @$router.push '/tanto'
    close: () ->
      @showChangePassword = false
    showPopup: (id) ->
      @id = @.$route.params.id
      @showChangePassword = true
  }
